import React, { forwardRef, memo } from 'react'

const DeliveryIcon = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      width={56}
      height={56}
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 56 56"
      fill="none"
      stroke="#78BE20"
      strokeWidth={1.4}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}>
      <circle
        cx={28}
        cy={28}
        r={26.871}
        fill="#fff"
        stroke="#eee"
        strokeWidth={2.259}
      />
      <path d="M32.9 23.8h3.726c.14 0 .276.042.392.12s.206.188.258.318l1.225 3.063" />
      <path d="M18.9 29.4H32.9" />
      <path d="M33.6 35.7a2.1 2.1 0 1 0 0-4.2 2.1 2.1 0 0 0 0 4.2Z" />
      <path d="M23.8 35.7a2.1 2.1 0 1 0 0-4.2 2.1 2.1 0 0 0 0 4.2Z" />
      <path d="M31.5 33.6h-5.6" />
      <path d="M32.9 27.3H38.5v5.6c0 .186-.078.364-.205.491a.7.7 0 0 1-.491.205H35.7" />
      <path d="M21.7 33.6H19.6a.7.7 0 0 1-.696-.696V23.1a.7.7 0 0 1 .696-.696H32.9v9.216" />
    </svg>
  )
)

DeliveryIcon.displayName = 'DeliveryIcon'
export default memo(DeliveryIcon)
